import { FilePen, Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Hai nút lưu chứng từ (plan-draft-and-save-buttons-v1):
 * - "Lưu nháp": ghi tạm, chỉ người tạo / Admin / Giám đốc thấy; không kiểm tra đủ thông tin.
 * - "Lưu": kiểm tra đầy đủ và chuyển chứng từ sang trạng thái 1 để bước tiếp theo xử lý.
 * "Lưu nháp" chỉ hiện khi chứng từ mới tạo hoặc đang là nháp.
 */
export function SaveActionButtons({
  status,
  busy,
  onSaveDraft,
  submitLabel = "Lưu",
  draftLabel = "Lưu nháp",
  submitType = "submit",
  onSubmitClick,
  disabled,
  submitDisabled,
}: {
  /** Trạng thái hiện tại của chứng từ (undefined = đang tạo mới) */
  status?: string | null;
  busy?: boolean;
  onSaveDraft: () => void;
  submitLabel?: string;
  draftLabel?: string;
  /** Nút Lưu là submit của form (mặc định) hay nút thường gọi onSubmitClick */
  submitType?: "submit" | "button";
  onSubmitClick?: () => void;
  /** Khoá cả hai nút */
  disabled?: boolean;
  /** Chỉ khoá nút "Lưu" (ví dụ form chưa hợp lệ) — "Lưu nháp" vẫn bấm được */
  submitDisabled?: boolean;
}) {
  const canDraft = !status || status === "DRAFT";
  return (
    <>
      {canDraft && (
        <Button
          type="button"
          variant="outline"
          data-testid="save-draft-button"
          disabled={busy || disabled}
          onClick={onSaveDraft}
          className="whitespace-nowrap h-9"
          title="Ghi tạm, chỉ bạn và quản trị thấy. Bổ sung đủ thông tin rồi bấm Lưu để chuyển bước tiếp theo."
        >
          <FilePen className="mr-2 h-4 w-4" /> {draftLabel}
        </Button>
      )}
      <Button
        type={submitType}
        data-testid="save-submit-button"
        disabled={busy || disabled || submitDisabled}
        onClick={submitType === "button" ? onSubmitClick : undefined}
        className="whitespace-nowrap h-9"
      >
        {busy ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Đang lưu...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" /> {submitLabel}
          </>
        )}
      </Button>
    </>
  );
}
